const namespace = "albaApp";

import AppConfig from "@/_config/application-config"
import childRoutes from "./routes"
import BrowserStorage from "@/_util/storage-modes.browser-storage";

const localStorage = new BrowserStorage(namespace);
const sessionStorage = new BrowserStorage(namespace, true);

const appConfig = {
  name: "alba",
  namespace,
  description: null,
  version: "1.0.0",
  icon: "mdi-gauge",
  parentRoute: "/alba",
  defaultRoute: "home",
  accentColor: "#000080",
  mainNavEnabled: false,
  topBarEnabled: false,
  childRoutes,
  component: () => import(/* webpackChunkName: "myapp-parent" */ "@/apps/alba/Application.vue"),

  settings: {
    environment: "",
    //apiUrl: "https://localhost:44339/api",
    //apiUrl: "https://as-alba-api-dev.azurewebsites.net/api",
	apiUrl: "https://api.nonprd.lyb.com/external/alba-dev/api",
    clientId: "bcab05cc-c6fd-458a-bda9-02a7ca5d3e49",
    scope: "api://bcab05cc-c6fd-458a-bda9-02a7ca5d3e49/Read.All",
    authorizeUrl: "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/authorize",
    tokenUrl: "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/token",
    logoutUrl: `https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/logout?post_logout_redirect_uri=${window.location.origin}`,
    redirect_uri: window.location.origin,
    env_color_dev: { "r": 96, "g": 125, "b": 139, "a": 1 },
    env_color_stg: { "r": 38, "g": 166, "b": 154, "a": 1 },
    appNavigation: [
      {
        icon: "mdi-home",
        text: "Accueil",
        link: "home",
        roles: ["admin", "businessadmin", "contributor", "readonly"]
      },
      {
        icon: "mdi-equal-box",
        text: "Gestions des stocks",
        link: "InventoryManagement",
        roles: ["admin", "businessadmin", "contributor", "readonly"]
      },
      {
        icon: "mdi-arrow-left-right-bold",
        text: "Gestion des mouvements",
        link: "MovementManagement",
        roles: ["admin", "businessadmin", "readonly"]
      },
      {
        icon: "mdi-monitor-dashboard",
        text: "Gestion des logés",
        link: "PipelineManagement",
        roles: ["admin", "businessadmin", "readonly"]
      },
      {
        icon: "mdi-alarm-panel-outline",
        text: "Saisie des compteurs",
        link: "EnteringMeters",
        roles: ["admin", "businessadmin", "contributor", "readonly"]
      },
      {
        icon: "mdi-arrow-down-bold-box",
        text: "Importation des fichiers",
        link: "ImportingFiles",
        roles: ["admin", "businessadmin"]
      },
      {
        icon: "mdi-table",
        text: "Gestion des logs",
        link: "LogManagement",
        roles: ["admin", "businessadmin"]
      },
      {
        icon: "mdi-account-multiple-outline",
        text: "Gestion des utilisateurs",
        link: "UserManagement",
        roles: ["admin", "businessadmin"]
      },
      {
        icon: "mdi-file-upload",
        text: "Initialisation",
        link: "Initialization",
        roles: ["admin"]
      },
      {
        icon: "mdi-wrench",
        text: "Parametre",
        link: "Parameters",
        roles: ["admin"]
      },

    ],
  },
  store: {
    //The store is made up of settings and attributes that should be accessible across components.
    //One common scenario would be user settings or profile preferences.  Some examples:
    //Date and Time Formats
    //Preferred configuration of a table view
    //Preferred theme color.
    pageTitle: {
      default: "albaApp Home",
      storageMode: localStorage,
    },
    userDetails: {
      default: null,
      storageMode: sessionStorage,
    },
    credentialCache: {
      default: {},
      storageMode: sessionStorage,
    },
    userRoles: {
      default: [],
      storageMode: sessionStorage,
    },
    navItems: {
      default: [],
      storageMode: sessionStorage,
    },
    themeColor: {
      default: "red",
      storageMode: localStorage,
    },
    isTrue: {
      default: true,
      storageMode: sessionStorage,
    },
  }

}

export default AppConfig.merge(appConfig);


